// extracted by mini-css-extract-plugin
export var columnList = "_gs-0";